/**
 * Every amount on a partner or composed invoice is in CENTS (para-node's
 * `PartnerInvoiceEntity` says so on `amount`, and the rest are written from the same Oatfi
 * figures). Nothing renders one raw.
 *
 * A missing value returns an em dash rather than `$0.00`: a zero is a real reading, and
 * showing one for absent data would state a balance the backend never reported.
 */
const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

const MISSING_VALUE = '—'

export const formatCentsAsUsd = (cents: number | null | undefined): string => {
  if (cents === null || cents === undefined) {
    return MISSING_VALUE
  }

  if (!Number.isFinite(cents)) {
    return MISSING_VALUE
  }

  return usdFormatter.format(cents / 100)
}

/**
 * `loanTransferRate` / `wireTransferRate` are decimal percents (`numeric(4,2)`), NOT cents —
 * `2.5` means 2.5%, so it is never divided by 100.
 */
export const formatRate = (rate: number | null | undefined): string => {
  if (rate === null || rate === undefined) {
    return MISSING_VALUE
  }

  if (!Number.isFinite(rate)) {
    return MISSING_VALUE
  }

  return `${rate.toFixed(2)}%`
}
